@if (multipleAccountsEnabled) {

  <form [formGroup]="form">
    <se-fe-form-field [seFeDataConfig]="payoutAccountFieldConfig">
      <se-fe-form-field-select
        formControlName="payoutAccounts"
        [seFeDataOptions]="payoutAccountOptions"
        [seFeDataComfy]="false"
        [seFeDataAllowClear]="false"
        [seFeDataPlaceholder]="'PAYOUT_ACCOUNT_SELECTOR.placeholder' | translate"></se-fe-form-field-select>
      <span
        class="help-text"
        seFeHelp>
        {{ 'PAYOUT_ACCOUNT_SELECTOR.help_text' | translate: { host: host } }}
      </span>
    </se-fe-form-field>
  </form>

}

@if (hasError) {
<se-fe-alert

  seFeDataType="error">
  {{ 'PAYOUT_ACCOUNT_SELECTOR.load_error' | translate }}
</se-fe-alert>
}
